import React from 'react';
import GroupList from '../components/GroupList';
import Header from '../components/header';
import Footer from '../components/footer';

const Groups = () => {
    return (
        <>
            <Header />
            <div className="container-fluid" style={{ marginTop: '80px', marginBottom: '60px' }}>
                <GroupList />
            </div>
            <Footer />
        </>
    );
};

export default Groups;
